import { Spin } from 'antd'
import { useTranslation } from 'react-i18next'

import styles from './style.module.scss'

const LoadingPage = () => {
  const { t } = useTranslation()

  return (
    <div className={styles.container}>
      <div>
        <Spin tip={t('loading')} />
      </div>
    </div>
  )
}

export default LoadingPage
